import { preserveCurrentSearch } from '@utils/navigationSearch';
import type { ReactElement } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { PortalPath } from './constants';
import { useMfaEnrollmentStatus } from './hooks/useMfaEnrollmentStatus';

export const MfaRestrictedRoute = ({ children }: { children: ReactElement }) => {
  const status = useMfaEnrollmentStatus();
  const [searchParams] = useSearchParams();
  if (status?.isPastDeadline) {
    return <Navigate to={preserveCurrentSearch(PortalPath.HOME, searchParams)} replace />;
  }
  return children;
};
